var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditPage } from "@/02-pages/edit";
import { TreePage } from "@/02-pages/tree";
import { getDocumentPath } from "@/06-shared/api";
import { useNotifyError } from "@/06-shared/lib/useNotifyError";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
export const NodePage = () => {
    const { nodeId: nodeIdParam } = useParams();
    const navigate = useNavigate();
    const showError = useNotifyError();
    const nodeId = Number(nodeIdParam);
    const isNodeIdValid = Number.isInteger(nodeId) && nodeId > 0;
    const [resolvedNode, setResolvedNode] = useState(null);
    useEffect(() => {
        if (!isNodeIdValid)
            return;
        let isActive = true;
        const resolveNode = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const path = yield getDocumentPath({ docId: nodeId });
                const node = path.at(-1);
                if (!node || !["document", "directory"].includes(node.type)) {
                    throw new Error("Unknown node type");
                }
                if (!isActive)
                    return;
                setResolvedNode({ id: nodeId, path });
            }
            catch (error) {
                if (!isActive)
                    return;
                showError(error);
                navigate("/", { replace: true });
            }
        });
        resolveNode();
        return () => {
            isActive = false;
        };
    }, [nodeId, isNodeIdValid]);
    if (!isNodeIdValid) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    if ((resolvedNode === null || resolvedNode === void 0 ? void 0 : resolvedNode.id) !== nodeId) {
        return null;
    }
    const node = resolvedNode.path.at(-1);
    return node.type === "document" ? (_jsx(EditPage, { documentId: nodeId, path: resolvedNode.path })) : (_jsx(TreePage, { currentDirectoryId: nodeId, path: resolvedNode.path }));
};
